import { useState, useEffect } from 'react'
import Tooltip from './tooltip'

const UserStatusIcon = ({ userId, onlyLabel }) => {
  const [reload, setReload] = useState(false)

  useEffect(() => {
    if (reload) setReload(false)
  }, [reload])

  useEffect(() => {
    window.addEventListener('message', handleWindowMessage)

    return () => {
      window.removeEventListener('message', handleWindowMessage)
    }
  })

  const handleWindowMessage = (e) => {
    if (!e.data) return
    switch (e.data.type) {
      case 'reload_avatar_status':
        setReload(true)
        break
    }
  }

  if (
    !window.appData ||
    !userId ||
    !window.appData.users_statuses_enabled ||
    window.appData.account_plan_functions.users_statuses != 'true' ||
    (!window.appData.users_statuses[userId] && !window.appData.users_statuses[userId.toString()]) ||
    !window.appData.statuses_settings
  ) {
    return ''
  }

  const setting = window.appData.statuses_settings.filter((s) => s.active != 'false' && (s.codename == window.appData.users_statuses[userId] || s.codename == window.appData.users_statuses[userId.toString()]))[0]

  if (setting && onlyLabel) {
    return (
      <span>{setting.default ? I18n.t(`status-icons.${setting.codename}`) : setting.name}</span>
    )
  }

  return (
    <>
      {setting ? (
        <span className="user-status-icon">
          <Tooltip content={setting.default ? I18n.t(`status-icons.${setting.codename}`) : setting.name}>
            <i className={setting.icon}></i>
          </Tooltip>
        </span>
      ) : null}
    </>
  )
}

export default UserStatusIcon
